// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LK8L","buttons":"styles_buttons__3M1jM"};